import React from 'react';
import { ModuleHeader } from '../shared/formFields';

export function PlaceholderModule({ title, subtitle, icon: Icon }) {
  return (
    <div className="space-y-4">
      <ModuleHeader title={title} />
      <div className="bg-white rounded-xl border border-slate-200 p-16 text-center">
        <Icon size={40} className="mx-auto text-slate-300 mb-3" />
        <div className="font-semibold text-[14px]" style={{ color: '#030524' }}>{title}</div>
        <div className="text-[12px] text-slate-500 mt-1 max-w-md mx-auto">{subtitle}</div>
      </div>
    </div>
  );
}
